/** 'yes' | 'no' | 'unknown' — from the cached `terminal_detect_programs` result. */
export function installState(detection, profile) {
  if (!(profile.command in detection)) return 'unknown';
  return detection[profile.command] ? 'yes' : 'no';
}

/**
 * The launch list's rows for `query`, in display (and ↑/↓) order: lead rows,
 * visible agents, shells, then "SSH connection…" when `showSsh`.
 */
export function buildLaunchRows({ query, leadRows, profiles, shells, showSsh, sshLabel }) {
  const q = query.trim().toLowerCase();
  const leads = leadRows.filter((r) => !q || r.label.toLowerCase().includes(q));
  const agents = profiles.filter((p) => !p.hidden && (!q || `${p.name} ${p.command}`.toLowerCase().includes(q)));
  const shellRows = shells.filter((s) => !q || s.label.toLowerCase().includes(q));
  const sshVisible = showSsh && (!q || sshLabel.toLowerCase().includes(q) || 'ssh'.includes(q));
  const rows = [
    ...leads.map((r) => ({ type: 'lead', key: `l:${r.key}`, lead: r })),
    ...agents.map((p) => ({ type: 'agent', key: `a:${p.id}`, profile: p })),
    ...shellRows.map((s) => ({ type: 'shell', key: `s:${s.key}`, shell: s })),
    ...(sshVisible ? [{ type: 'ssh', key: 'ssh' }] : []),
  ];
  return { leads, agents, shellRows, sshVisible, rows };
}
